export default "__VITE_ASSET__mM7GH3rn__"